import { t } from "../../i18n/t";

/**
 * xmg-autoanswer: who answered a review item, in words. A `rule:<name>` actor is a deterministic rule the server
 * applied at mapping time (`workflow/review_rules.py`); it reads as "a rule (...)" rather than the raw actor id,
 * and it stays a default the operator may change while the mapping is still under review.
 */
export const RULE_ACTOR_PREFIX = "rule:";

function ruleLabel(name: string): string {
  // Literal `t(...)` calls, so `tests/i18n.test.ts` sees every key referenced.
  switch (name) {
    case "acknowledge_only_warning":
      return t("review.rule_acknowledge_only_warning");
    case "mapper_suggestion":
      return t("review.rule_mapper_suggestion");
    case "fx_convention_from_payments":
      return t("review.rule_fx_convention_from_payments");
    case "reverse_charge_from_supplier_country":
      return t("review.rule_reverse_charge_from_supplier_country");
    case "journals_gap_report_penny":
      return t("review.rule_journals_gap_report_penny");
    default:
      return t("review.rule_unknown");
  }
}

export function isRuleActor(actor: string | null | undefined): boolean {
  return actor !== null && actor !== undefined && actor.startsWith(RULE_ACTOR_PREFIX);
}

export function actorLabel(actor: string | null | undefined): string {
  if (actor === null || actor === undefined || actor === "") {
    return t("review.actor_unknown");
  }
  if (!isRuleActor(actor)) {
    return actor;
  }
  return t("review.actor_rule", { rule: ruleLabel(actor.slice(RULE_ACTOR_PREFIX.length)) });
}
